import React from 'react';
import { connect } from 'react-redux';
import StatisticsByDayContent from './StatisticsByDayContent.js';
import { actions } from './StatisticsByDayContent.actions';

const StatisticsByDayContentComponent = connect(
    function mapStateToProps(state) {
        const storedMetrics = state?.statistics?.data?.parameters?.metricsBinary
            || state?.serverStorage?.store?.reportByDay?.metrics;
        return {
            loadingData: state.statistics.data.loading,
            totalPages: state.statistics.data.total,
            page: state.statistics.data.page,
            metrics: typeof storedMetrics === 'string' ? storedMetrics : '',
            serverStorageReady: !!state.serverStorage.loaded
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            search: actions.search,
            setQuery: actions.setQuery
        };
    }
)(StatisticsByDayContent);

export default StatisticsByDayContentComponent;
